module.exports = __webpack_public_path__ + "img/reeducacao@2x.b8d9f0e1.png";